<template>
  <MDropdown ref="dropdownMenu">
    <template v-slot:trigger>
      <MButton
        id="action-btn"
        variant="neutral-lighter"
        class="ml-1"
        :shadow="false"
        shape="circle"
      >
        <MIcon name="ellipsis-v" size="2x" />
      </MButton>
    </template>
    <template v-slot:menu>
      <MMenu class="action-menu">
        <MMenuItem id="print">
          <Print
            support-portal-print
            :resource-id="resourceId"
            :resource="resource"
            :module-name="moduleName"
            @trigger="hide"
          />
        </MMenuItem>
      </MMenu>
    </template>
  </MDropdown>
</template>

<script>
import Print from '@src/modules/ticket/components/action-menu-items/print'

export default {
  name: 'ActionMenu',
  components: {
    Print,
  },
  props: {
    moduleName: { type: String, required: true },
    resourceId: { type: Number, default: undefined },
    resource: { type: Object, required: true },
  },
  methods: {
    hide() {
      this.$refs.dropdownMenu.hide()
    },
  },
}
</script>
